import { Component } from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {GlobalProvider} from "../../providers/global/global";
import {DataProvider} from "../../providers/dataprovider/dataprovider";

/**
 * Generated class for the SettingTeamInvitationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting-team-invitation',
  templateUrl: 'setting-team-invitation.html',
})
export class SettingTeamInvitationPage {

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private http: HttpClient,
              private globalProvider: GlobalProvider,
              private alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingTeamInvitationPage');
  }

  public onSubmit(formValues: any): void {

    this.http.post(this.globalProvider.apiURL + "/v1/inviteTeam", {email: formValues.email, databaseUUID: this.globalProvider.database.uuid, currentUser: this.globalProvider.user.uuid})
      .subscribe((response) => {
        let successAlert = this.alertCtrl.create({
          title: 'Einladung versendet',
          subTitle: 'Die Einladung zum Beitritt Ihres Teams wurde versendet.',
          buttons: ['Ok']
        });
        successAlert.present();
      }, (error) => {
        let errorAlert = this.alertCtrl.create({
          title: 'Fehler!',
          subTitle: 'Die Einladung konnte nicht versendet werden. Bitte versuchen Sie es erneut oder wenden Sie sich an support@cleverreport.de',
          buttons: ['Ok']
        });
        errorAlert.present();
      })


  }

}



// WEBPACK FOOTER //
// ./src/pages/setting-team-invitation/setting-team-invitation.ts